import React from 'react';
import { BRAND } from '../brand';
import { LegalDocLayout } from '../components/LegalDocLayout';

const Privacidad = () => {
  const cityPlaceholder = BRAND.legalCity || '[CIUDAD DEL DOMICILIO LEGAL — PENDIENTE CLIENTE]';
  const wa = BRAND?.landing?.footerWhatsAppNumber;
  const waDisplay = BRAND?.landing?.footerWhatsAppDisplay || (wa ? `+${wa}` : null);
  const primary = BRAND?.theme?.primary || '#15803D';

  const sections = [
    { title: 'Quiénes somos', body: (
      <>
        <p>{BRAND.name} es operado por <strong>{BRAND.legalName.toUpperCase()}</strong> (en adelante {BRAND.name} o "nosotros"), empresa formalizada en Chile y con domicilio comercial en {cityPlaceholder}. Nuestra actividad principal es facilitar transferencias internacionales de dinero entre Chile y Perú, y otros países según disponibilidad publicada en {BRAND.name}.</p>
        <ul className="list-disc list-inside ml-2 space-y-1">
          <li>Email: <a href={`mailto:contacto@${BRAND.domain}`} className="underline" style={{ color: primary }}>contacto@{BRAND.domain}</a></li>
          {wa && <li>WhatsApp: <a href={`https://wa.me/${wa}`} className="underline" style={{ color: primary }}>{waDisplay}</a></li>}
          <li>Sitio: <a href={`https://${BRAND.domain}`} className="underline" style={{ color: primary }}>https://{BRAND.domain}</a></li>
        </ul>
      </>
    )},
    { title: 'Qué datos recopilamos', body: (
      <>
        <p>Recopilamos únicamente los datos necesarios para prestar el servicio de forma segura y cumplir con las obligaciones legales:</p>
        <ul className="list-disc list-inside ml-2 space-y-1">
          <li><strong>Identidad</strong>: nombre, RUT/DNI, fecha de nacimiento, nacionalidad, cédula/pasaporte (imagen).</li>
          <li><strong>Contacto</strong>: correo electrónico, teléfono, dirección.</li>
          <li><strong>Financieros de transacción</strong>: origen y destino del envío, monto, medio de pago, comprobantes.</li>
          <li><strong>Técnicos</strong>: dirección IP, dispositivo, sistema operativo, geolocalización aproximada, cookies estrictamente necesarias.</li>
          <li><strong>Selfie</strong>: para verificar identidad (KYC) y evitar suplantación.</li>
        </ul>
      </>
    )},
    { title: 'Para qué usamos tus datos', body: (
      <ul className="list-disc list-inside ml-2 space-y-1">
        <li>Ejecutar tu transferencia y notificarte su estado.</li>
        <li>Verificar tu identidad (KYC) y prevenir fraude.</li>
        <li>Reportar operaciones sospechosas a la UAF cuando corresponda (Ley 19.913).</li>
        <li>Emitir boletas o comprobantes tributarios cuando aplique.</li>
        <li>Enviarte notificaciones operativas por WhatsApp, email y push.</li>
        <li>Mejorar el servicio (analítica agregada, no perfilamiento comercial invasivo).</li>
      </ul>
    )},
    { title: 'Base legal', body: (
      <p>El tratamiento se sustenta en: (i) tu consentimiento expreso al aceptar estos términos; (ii) la ejecución del contrato de transferencia; (iii) el cumplimiento de obligaciones legales chilenas (Ley 19.913, SII, protección al consumidor). Puedes retirar tu consentimiento en cualquier momento; retirar el consentimiento no afecta la licitud de los tratamientos previos.</p>
    )},
    { title: 'Con quién compartimos tus datos', body: (
      <>
        <p>No vendemos ni cedemos tus datos con fines comerciales. Los compartimos únicamente con:</p>
        <ul className="list-disc list-inside ml-2 space-y-1">
          <li>Bancos y procesadores de pago involucrados en tu transferencia.</li>
          <li>Autoridades competentes (UAF, SII, tribunales) cuando la ley lo exige.</li>
          <li>Proveedores tecnológicos con acuerdos de confidencialidad y encargo de tratamiento (hosting, autenticación, envío de notificaciones).</li>
        </ul>
      </>
    )},
    { title: 'Retención y eliminación', body: (
      <p>Conservamos tus datos mientras tu cuenta esté activa y por los plazos que imponga la ley (5 años en general para registros de operaciones y KYC, según Ley 19.913 y normativa UAF). Puedes solicitar la eliminación de tu cuenta escribiéndonos a <a href={`mailto:contacto@${BRAND.domain}`} className="underline" style={{ color: primary }}>contacto@{BRAND.domain}</a>. Los datos que estamos obligados a conservar por ley se mantendrán con acceso restringido hasta el vencimiento del plazo legal.</p>
    )},
    { title: 'Tus derechos', body: (
      <p>Como titular de datos puedes ejercer los derechos <strong>ARCO</strong>: acceso, rectificación, cancelación y oposición. Escríbenos a <a href={`mailto:contacto@${BRAND.domain}`} className="underline" style={{ color: primary }}>contacto@{BRAND.domain}</a> identificándote con tu RUT y el motivo de la solicitud. Respondemos en un plazo máximo de 15 días hábiles.</p>
    )},
    { title: 'Cookies', body: (
      <p>Usamos cookies estrictamente necesarias para el funcionamiento del sitio (sesión, seguridad). No usamos cookies de terceros con fines publicitarios ni de perfilamiento cruzado. Podés bloquear cookies desde tu navegador, pero el sitio podría no funcionar correctamente.</p>
    )},
    { title: 'Seguridad', body: (
      <p>Aplicamos cifrado en tránsito (HTTPS/TLS) y en reposo para datos sensibles. Restringimos el acceso a los datos por rol y monitoreamos accesos. Ante un incidente de seguridad que afecte tus datos, te notificaremos sin demora indebida junto con las medidas correctivas adoptadas.</p>
    )},
    { title: 'Cambios a esta política', body: (
      <p>Podemos actualizar esta política cuando cambien nuestras prácticas o la normativa aplicable. Publicaremos la fecha de última actualización arriba y, cuando el cambio sea material, te avisaremos por email o al iniciar sesión.</p>
    )},
    { title: 'Contacto', body: (
      <p>Para preguntas sobre privacidad o para ejercer tus derechos: <a href={`mailto:contacto@${BRAND.domain}`} className="underline" style={{ color: primary }}>contacto@{BRAND.domain}</a>{wa && <> · <a href={`https://wa.me/${wa}`} className="underline" style={{ color: primary }}>{waDisplay}</a></>}.</p>
    )},
  ];

  return (
    <LegalDocLayout
      title={`Política de Privacidad de ${BRAND.name}`}
      updatedAt="15 de julio de 2026"
      sections={sections}
    />
  );
};

export default Privacidad;
